import UIFormLabel from 'UIComponents/form/UIFormLabel';
import { useThemeStore } from 'academy-common-lib/utils/Styling';
import { ThemedToggle } from '../../../components/ThemedComponents';
import usageTracker from '../../../utils/usageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicPageThemeToggle = () => {
  const {
    theme,
    setTheme
  } = useThemeStore();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    inlineSize: "inherit",
    children: [/*#__PURE__*/_jsx(ThemedToggle, {
      checked: theme === 'highContrast',
      id: "high-contrast-toggle",
      marginInlineEnd: "200",
      onChange: e => {
        if (e.target.checked) {
          setTheme('highContrast');
        } else {
          setTheme('light');
        }
        usageTracker.track('navInteraction', {
          action: 'theme-toggled',
          value: e.target.checked ? 'highContrast' : 'light'
        });
      },
      size: "small"
    }), /*#__PURE__*/_jsx(UIFormLabel, {
      htmlFor: "high-contrast-toggle",
      style: {
        fontWeight: 400
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.publicNav.highContrast"
      })
    })]
  });
};
export default PublicPageThemeToggle;